import masterRepository from '@master/master.module';
import { GetSubjectUniversityOptionListBody } from '@master/models/get-subject-university-option-list.model';
import { useQuery } from '@tanstack/react-query';

// #region Constants
export const SUBJECT_UNIVERSITY_OPTION_LIST_QUERY_KEY = 'subject-university-option-list';
// #endregion

export default function useSubjectUniversityOptionList() {
  // #region Query
  const { data, isLoading } = useQuery<GetSubjectUniversityOptionListBody | undefined>({
    queryFn: async ({ signal }) => {
      const response = await masterRepository.getSubjectUniversityOptionList(signal);
      return response.body;
    },
    queryKey: [SUBJECT_UNIVERSITY_OPTION_LIST_QUERY_KEY],
  });
  // #endregion

  return { data, isLoading };
}
